import { render } from "./BarrierDiagramByYear.vue?vue&type=template&id=97d09e4a&scoped=true"
import script from "./BarrierDiagramByYear.vue?vue&type=script&lang=js"
export * from "./BarrierDiagramByYear.vue?vue&type=script&lang=js"

import "./BarrierDiagramByYear.vue?vue&type=style&index=0&id=97d09e4a&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97d09e4a"]])

export default __exports__